import { EDeliverableStatus } from '@constants';
import { IDeliverable } from '@sdk/contracts';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DeliverableCourse,
  DeliverableInfo,
  DeliverableName,
  IconWrapper,
  NoteText,
  NoteWrapper,
  StatusText,
  Wrapper
} from './DeliverableItem.styles';

import { Icon } from '@/components/Icon';
import { getFileIcon } from '@/utils/fileIcon';

interface DeliverableItemProps {
  deliverable: IDeliverable;
}

export const DeliverableItem: FC<DeliverableItemProps> = ({ deliverable }) => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const iconName = getFileIcon(deliverable.file.name);

  const getDeliverableStatus = () => {
    if (deliverable.status === EDeliverableStatus.COMPLETED) {
      return deliverable.score ? deliverable.score : t('COMPLETED');
    }
    if (deliverable.status === EDeliverableStatus.IN_REVIEW) {
      return t('IN_REVIEW');
    }
    return t('DELIVERED');
  };

  return (
    <Wrapper>
      <DeliverableInfo>
        <IconWrapper iconName={iconName}>
          <Icon size={18} i={iconName} color="white" />
        </IconWrapper>
        <div>
          <DeliverableName>{deliverable.activity.name}</DeliverableName>
          <DeliverableCourse>{deliverable.course.name}</DeliverableCourse>
        </div>
      </DeliverableInfo>
      <NoteWrapper>
        <NoteText>{t('NOTE')}</NoteText>
        <StatusText $status={deliverable.status}>{getDeliverableStatus()}</StatusText>
      </NoteWrapper>
    </Wrapper>
  );
};
